import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import internalRoutes from '@/router/routes/internal.js'
import masterRoutes from '@/router/routes/master.js'
import archiveRoutes from '@/router/routes/archive.js'

export default allRoutes.concat(
  publicRoutes,
  privateRoutes,
  internalRoutes,
  masterRoutes,
  archiveRoutes
)